import { render, staticRenderFns } from "./Gamburger.vue?vue&type=template&id=1ac57977&scoped=true&"
import script from "./Gamburger.vue?vue&type=script&lang=js&"
export * from "./Gamburger.vue?vue&type=script&lang=js&"
import style0 from "./Gamburger.vue?vue&type=style&index=0&id=1ac57977&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac57977",
  null
  
)

export default component.exports